"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDisplayName = void 0;
const getDisplayName = (Component) => {
    if (typeof Component === "string") {
        return Component;
    }
    if (!Component) {
        return undefined;
    }
    return Component.displayName || Component.name || "Component";
};
exports.getDisplayName = getDisplayName;
//# sourceMappingURL=getDisplayname.js.map